import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ticket, X } from "lucide-react";
import api from "@/lib/api";

export default function ExpiringCouponBanner() {
  const [coupon, setCoupon] = useState(null);

  useEffect(() => {
    const wa = localStorage.getItem("gu_customer_wa");
    if (!wa) return;
    api.get("/referral/my-coupons", { params: { whatsapp: wa } })
      .then(({ data }) => {
        const now = Date.now();
        const soon = now + 5 * 24 * 3600 * 1000;
        const expiring = (data.coupons || []).filter((c) => {
          if (c.status !== "active" || !c.expires_at) return false;
          const t = new Date(c.expires_at).getTime();
          return t > now && t <= soon && !localStorage.getItem(`gu_coupon_banner_dismissed_${c.code}`);
        }).sort((a, b) => new Date(a.expires_at) - new Date(b.expires_at));
        if (expiring.length) setCoupon(expiring[0]);
      })
      .catch(() => {});
  }, []);

  if (!coupon) return null;

  const expiry = new Date(coupon.expires_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

  return (
    <div data-testid="expiring-coupon-banner" className="bg-amber-50 border-b border-amber-200 px-4 py-2.5">
      <div className="max-w-7xl mx-auto flex items-center gap-2.5 text-[13px] text-amber-900">
        <Ticket size={15} className="shrink-0 text-amber-600" />
        <p className="flex-1 min-w-0">
          Your coupon <code className="font-bold tracking-widest">{coupon.code}</code> (₹{Number(coupon.amount_inr).toLocaleString("en-IN")} off) expires on <strong>{expiry}</strong> — use it before it's gone!
        </p>
        <Link to="/" data-testid="expiring-coupon-use-link" className="shrink-0 text-[12px] font-bold text-amber-800 underline hover:text-amber-950">
          Use Now
        </Link>
        <button type="button" data-testid="expiring-coupon-dismiss-btn" aria-label="Dismiss"
          onClick={() => { localStorage.setItem(`gu_coupon_banner_dismissed_${coupon.code}`, "1"); setCoupon(null); }}
          className="shrink-0 text-amber-700 hover:text-amber-950">
          <X size={15} />
        </button>
      </div>
    </div>
  );
}
